export const SubtitleValues = [
    "subtitles.personalInformation",
    "subtitles.personalFamilyHistory",
    "subtitles.familyHistory",
    "subtitles.additionalInformation",
    "subtitles.inOffice",
    "subtitles.assessmentResults",
    "t404p.resultsTitle",
    "t404p.paymentBreakdown.title",
    "chatbot.personalInformation.subtitle",
];
export var NodeTypes;
(function (NodeTypes) {
    NodeTypes["Page"] = "PAGE";
    NodeTypes["CancerHistory"] = "CANCER_HISTORY";
    NodeTypes["BreastCancerRisk"] = "BREAST_CANCER_RISK";
    NodeTypes["Review"] = "REVIEW";
    NodeTypes["BloodTransfusion"] = "BLOOD_TRANSFUSION";
    NodeTypes["ColonPolyp"] = "COLON_POLYP";
    NodeTypes["PersonalHistory"] = "PERSONAL_HISTORY";
    NodeTypes["FamilyHistory"] = "FAMILY_HISTORY";
    NodeTypes["ContextCompletion"] = "CONTEXT_COMPLETION";
    NodeTypes["ContextBreak"] = "CONTEXT_BREAK";
    NodeTypes["EndpointCall"] = "ENDPOINT_CALL";
    NodeTypes["Redirect"] = "REDIRECT";
    NodeTypes["Content"] = "CONTENT";
    NodeTypes["Chat"] = "CHAT";
    NodeTypes["ChatModalNode"] = "CHAT_MODAL_NODE";
    NodeTypes["MrnInfo"] = "MRN_INFO";
})(NodeTypes || (NodeTypes = {}));
export var ContinueType;
(function (ContinueType) {
    ContinueType["Fixed"] = "FIXED";
    ContinueType["End"] = "END";
    ContinueType["AutoFixed"] = "AUTO-FIXED";
    ContinueType["AutoEnd"] = "AUTO-END";
})(ContinueType || (ContinueType = {}));
export var DetailsType;
(function (DetailsType) {
    DetailsType["Self"] = "SELF";
    DetailsType["Relative"] = "RELATIVE";
    DetailsType["Both"] = "BOTH";
})(DetailsType || (DetailsType = {}));
export var BreastCancerRiskType;
(function (BreastCancerRiskType) {
    BreastCancerRiskType["Provider"] = "PROVIDER";
    BreastCancerRiskType["TcScore"] = "TC-SCORE";
})(BreastCancerRiskType || (BreastCancerRiskType = {}));
export var ChatModalNodeType;
(function (ChatModalNodeType) {
    ChatModalNodeType["MrnInfo"] = "MRN_INFO";
    ChatModalNodeType["PersonalInfo"] = "PERSONAL_INFO";
    ChatModalNodeType["CancerHistory"] = "CANCER_HISTORY";
    ChatModalNodeType["CancerHistorySelf"] = "CANCER_HISTORY_SELF";
    ChatModalNodeType["CancerHistoryFamily"] = "CANCER_HISTORY_FAMILY";
    ChatModalNodeType["MedicalHistory"] = "MEDICAL_HISTORY";
    ChatModalNodeType["BreastCancerRisk"] = "BREAST_CANCER_RISK";
    ChatModalNodeType["HideResults"] = "HIDE_RESULTS";
})(ChatModalNodeType || (ChatModalNodeType = {}));
